import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { SelectModule } from 'src/app/common-components/entity-select/select/select.module';
import { PhoneIssuesChipAndMenuModule } from 'src/app/common-components/phone-issues-chip-and-menu/phone-issues-chip-and-menu.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AccountDeviceRegisterComponent } from './account-device-register/containers/account-device-register.component';
import { AccountDeviceRegisterViewComponent } from './account-device-register/views/account-device-register-view.component';
import { DeviceRegisterEffects } from './state/device-register.effects';
import { deviceRegisterFeatureKey, deviceRegisterReducer } from './state/device-register.reducer';
import { SystemDeviceRegisterComponent } from './system-device-register/containers/system-device-register.component';
import { SystemDeviceRegisterViewComponent } from './system-device-register/views/system-device-register-view.component';

@NgModule({
   declarations: [
      SystemDeviceRegisterViewComponent,
      SystemDeviceRegisterComponent,
      AccountDeviceRegisterComponent,
      AccountDeviceRegisterViewComponent,
   ],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      PhoneIssuesChipAndMenuModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      SelectModule,
      EntitySelectModule,
      MatSlideToggleModule,
      MatCheckboxModule,
      MatMenuModule,
      ReactiveFormsModule,
      RouterModule,
      ScrollingModule,
      RegisterModule,
      LocationModule,
      FormatPhoneNumbersPipeModule,
      EffectsModule.forFeature([DeviceRegisterEffects]),
      StoreModule.forFeature(deviceRegisterFeatureKey, deviceRegisterReducer),
   ],
})
export class DeviceRegisterModule {}
